import Store from '@/store';
import { ColorRequestConfig } from '@/interfaces/components/color/ColorRequestConfig';
import { ColorFilters } from '@/interfaces/components/color/ColorFilters';

export const FiltersConfiguration = [
    // {
    //     options: () => Store.getters['colorData/charts'],
    //     label: 'Color system',
    //     type: 'colorSystem',
    //     filter: 'colorChart',
    //     fieldType: 'dropdown',
    //     isMandatory: true,
    //     isActive: () => false,
    // },
    {
        options: () => Store.getters['colorData/collections'],
        label: 'Color collection',
        type: 'colorCollection',
        // filter: 'defaultPowder.colorCollection',
        filter: 'colorCollection',
        fieldType: 'dropdown',
        isMandatory: true,
        defaultValue: '1',
        isActive: (activeTab: string) => activeTab !== 'color-request',
    },
    {
        options: () => Store.getters['colorData/surfaces'],
        label: 'Gloss/Surface',
        type: 'colorSurface',
        filter: 'colorSurface',
        fieldType: 'dropdown',
        isMandatory: false,
        info: 'Indicates the level of gloss (e.g., matte, semi-gloss, high-gloss) and texture of the coating.',
        isActive: () => true,
    },
    {
        options: () => Store.getters['colorData/effects'],
        label: 'Effect',
        type: 'colorEffect',
        filter: 'colorEffect',
        fieldType: 'dropdown',
        isMandatory: false,
        info: 'Describes special visual properties of the color, such as metallic, pearl, or structured finishes.',
        isActive: () => true,
    },
    {
        options: () => Store.getters['colorData/qualities'],
        label: 'Quality',
        type: 'colorQuality',
        filter: 'colorQuality',
        fieldType: 'dropdown',
        isMandatory: false,
        info: 'Defines the durability and resistance of the color, including factors like weather resistance and longevity.',
        isActive: () => true,
    },
];

export const MappedColorCollections = {
    STANDARD: 'STANDARD',
    INDIVIDUAL: 'NESTANDARDEN RAL',
    'RAL KLASIK': 'NESTANDARDEN RAL',
    'RAL TREND': 'NESTANDARDEN RAL',
    ELOX: 'ELOX',
    'LESNA IMITACIJA': 'LESNA IMITACIJA',
};

export const MappedColorCodes: Record<string, string> = {
    'Bela FS': 'P1',
    'Srebrna FS': 'P2',
    'DB 703 FS': 'P3',
    'Antracit FS': 'P4',
    'Limona FS': 'A1',
    'Bež FS': 'A2',
    'Temno bež FS': 'A3',
    'Rjavo siva FS': 'A4',
    'Bledo rjava FS': 'A5',
    'Zemeljsko rjava FS': 'A6',
    'Jekleno rjava FS': 'A7',
    'Čok.t. FS': 'A8',
    'Bakrena FS': 'A9',
    'Orehovo rjava FS': 'A10',
    'Mahagonij rjava FS': 'A11',
    'Čok.sv. FS': 'A12',
    'Olivna FS': 'A13',
    'Zeleno siva FS': 'A14',
    'Kamnito siva FS': 'A15',
    'Svileno siva FS': 'A16',
    'Siva FS': 'A17',
    'Ledeno siva FS': 'A18',
    'Srebrno siva FS': 'A19',
    'Sivi aluminij FS': 'A20',
    'Temno siva FS': 'A21',
    'Pepelno siva FS': 'A22',
    'Vulkansko črna FS': 'A23',
    'Črna FS': 'A24',
};

export const RoltekColorCollections = new Set(['STANDARD', 'ELOX', 'LESNA IMITACIJA']);

export const formatCustomColor = function (colorConfig: ColorRequestConfig, colorFilters: ColorFilters) {
    const values = [
        colorConfig?.colorName,
        colorConfig?.colorProducer,
        colorFilters?.colorSystem?.value,
        colorConfig?.powderID,
        colorFilters?.colorGloss?.value,
        colorFilters?.colorSurface?.value,
        colorFilters?.colorEffect?.value,
        colorFilters?.colorQuality?.value,
    ];

    return values.filter((value) => value).join(' | ');
};

export const formatColorSearchQuery = function (filters: ColorFilters, searchText: string = '') {
    let query = '';

    if (searchText) {
        query += `&search=${searchText}`;
    }

    if (filters) {
        for (const key in filters) {
            if (!filters[key as keyof ColorFilters]?.id) {
                continue;
            }

            if (filters[key as keyof ColorFilters]) {
                const filterConfig = FiltersConfiguration.find((filter) => filter.type === key);
                // const prefix = filterConfig?.isMandatory ? '' : 'powders.';

                query += `&filter[${filterConfig?.filter}.id]=${filters[key as keyof ColorFilters]?.id}`;
            }
        }
    }

    return query;
};

export const formatSelectedColorForCustomRequest = function (selectedColor: any, powder: any) {
    if (!powder) {
        if (!selectedColor) return '';
        return selectedColor?.description ?? '';
    }

    return powder?.description ?? '';
};
